import { Search } from "lucide-react";

export default function SearchBox({ value, onChange }) {
  return (
    <div className="relative w-full max-w-sm">
      <Search
        size={18}
        className="absolute left-3 top-3 text-gray-400"
      />

      <input
        type="text"
        placeholder="Search..."
        value={value}
        onChange={onChange}
        className="w-full border border-gray-300 rounded-xl pl-10 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#FED547]"
      />
    </div>
  );
}